import { render, staticRenderFns } from "./CreateModelCmi.vue?vue&type=template&id=32dc074e&"
import script from "./CreateModelCmi.vue?vue&type=script&lang=js&"
export * from "./CreateModelCmi.vue?vue&type=script&lang=js&"
import style0 from "./CreateModelCmi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports